export class IconSpriteConfig {
  public path: string;
}
